<div class="auth-container">
    <div class="auth-card">
        <div class="auth-header">
            <img src="opscribe_logo3.png" alt="Opscribe Logo" class="auth-logo">
            <h2>Create Account</h2>
        </div>

        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">

            <div class="form-row">
                <div class="form-group half">
                    <label for="firstName">First Name</label>
                    <input id="firstName" type="text" formControlName="firstName" placeholder="First name"
                        [class.invalid]="registerForm.get('firstName')?.invalid && registerForm.get('firstName')?.touched">
                </div>
                <div class="form-group half">
                    <label for="lastName">Last Name</label>
                    <input id="lastName" type="text" formControlName="lastName" placeholder="Last name"
                        [class.invalid]="registerForm.get('lastName')?.invalid && registerForm.get('lastName')?.touched">
                </div>
            </div>

            <div class="form-group">
                <label for="phone">Phone (Optional)</label>
                <input id="phone" type="tel" formControlName="phone" placeholder="Phone number">
            </div>

            <div class="form-group">
                <label for="email">Email</label>
                <input id="email" type="email" formControlName="email" placeholder="Enter your email"
                    [class.invalid]="registerForm.get('email')?.invalid && registerForm.get('email')?.touched">
            </div>

            <div class="form-group">
                <label for="password">Password</label>
                <input id="password" type="password" formControlName="password" placeholder="Create a password"
                    [class.invalid]="registerForm.get('password')?.invalid && registerForm.get('password')?.touched">
            </div>

            <div class="form-group">
                <label for="confirmPassword">Confirm Password</label>
                <input id="confirmPassword" type="password" formControlName="confirmPassword"
                    placeholder="Confirm your password"
                    [class.invalid]="registerForm.get('confirmPassword')?.invalid && registerForm.get('confirmPassword')?.touched">
            </div>

            <button type="submit" [disabled]="registerForm.invalid || isLoading" class="btn-primary">
                <span *ngIf="!isLoading">Sign Up</span>
                <span *ngIf="isLoading">Creating Account...</span>
            </button>

            <div *ngIf="errorMessage" class="error-alert">
                {{ errorMessage }}
            </div>
        </form>

        <div class="auth-footer">
            <p>Already have an account? <a routerLink="/login">Sign in</a></p>
        </div>
    </div>
</div>